import { createFileRoute } from "@tanstack/react-router";

import { DesignSystemInnerLayout } from "@/app/design-system/DesignSystemLayout";

export const Route = createFileRoute("/admin/design-system")({
  component: DesignSystemInnerLayout,
});
